import { getDocumentationUrl } from '@gonfalon/docs/documentationUrl';
import { LinkIconButton, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

type HealthCheckDocumentationLinkProps = {
  /** URL to the documentation */
  url: string;
  /** Text displayed in tooltip when button is hovered */
  label?: string;
  /** Optional callback when link is clicked, e.g. for event tracking */
  onClick?: () => void;
};

export function HealthCheckDocumentationLink({
  url,
  label = 'Go to health check documentation',
  onClick,
}: HealthCheckDocumentationLinkProps) {
  const destination = getDocumentationUrl(url);

  return (
    <TooltipTrigger>
      <LinkIconButton
        icon="book-external-link"
        aria-label={label}
        size="small"
        variant="minimal"
        href={destination}
        onClick={onClick}
        target="_blank"
      />
      <Tooltip>{label}</Tooltip>
    </TooltipTrigger>
  );
}
